export default __webpack_public_path__ + "static/media/porterbuddy_grey_landscape.aa37d683.svg";